<template>
  <div class="card card-shadow card-rounded border-0 mb-4">
    <LoanOverdueMessage :loan="loan" v-if="loan.status === 'DELAYED'"></LoanOverdueMessage>
    <LoanUnpaidMessage :loan="loan" v-else-if="loan.status === 'NORMAL_UNPAID'"/>
    <div class="card-body">
      <div class="row">
        <div v-if="loan.overdueDays > 0" class="col-6 form-group">
          <div class="text-warning" id="loan-overdue-days">
            {{ $tc('LoanDetailsPage.overdueDays', loan.overdueDays) }}
          </div>
        </div>
        <div class="col-6 form-group" id="loan-overdue-to-be-paid">
          <div class="small text-muted">{{ $t('LoanDetailsPage.toBePaid') }}</div>
          <strong>{{ $n(loan.toBePaid, 'currency') }}</strong>
        </div>
      </div>
      <LoanCardActions :loan="loan" :showCalculator="showCalculator" />
    </div>
  </div>
</template>
<script>
import LoanOverdueMessage from '@shared/components/loan/details/LoanOverdueMessage'
import LoanCardActions from '@shared/components/loan/details/LoanCardActions'
import LoanUnpaidMessage from '@shared/components/loan/details/LoanUnpaidMessage'

export default {
  name: 'DelayedLoanCard',
  props: ['loan'],
  components: {
    LoanOverdueMessage,
    LoanCardActions,
    LoanUnpaidMessage
  },
  computed: {
    showCalculator() {
      return !this.$configuration.newCoreEnabled
    }
  }
}
</script>
